import filter from 'lodash/filter';
import intersection from 'lodash/intersection';
import some from 'lodash/some';

const securityPermissions = {
  filterSitesByPermissions<SiteWithPermissions extends { permissions: Array<string> }>(
    sites: Array<SiteWithPermissions>,
    permissionToCheck: Array<string>,
  ) {
    return filter(sites, (s) => !!intersection(s.permissions, permissionToCheck).length);
  },

  checkPermissions(sitePermissions: Array<string>, permissionToCheck: string) {
    return some(sitePermissions, (permission) => permission === permissionToCheck);
  },
};

export default securityPermissions;
